// extracted by mini-css-extract-plugin
export default {"editInfoWrapper":"Edit_editInfoWrapper__KqaCl","editInfo":"Edit_editInfo__QiW5x","titleSect":"Edit_titleSect__Qcg9A","title":"Edit_title__HmbSG","info":"Edit_info__rm7TF"};